/** Static copy for the advisor detail page, ported from lpr-web `advisors:advisorInner.*`. */

export interface AdvisorFaq {
  question: string
  answer: string
}

export const advisorInnerFaqs: AdvisorFaq[] = [
  {
    question: "When can I get a consultation with an advisor?",
    answer:
      "Our advisors are available for you anytime — day or night. As soon as you’re ready to connect, simply open the chat and begin your session. To start a conversation, you’ll need Stars, our in-app currency. As a welcome gift, we provide free Stars to all new users,  so you can experience your first consultation without delay or commitment!",
  },
  {
    question: "What are the ways to communicate?",
    answer:
      "All communication with advisors takes place through real-time chat inside the app. Simply type your question, and one of our professional psychics will respond directly to you. This allows for private, direct, and convenient guidance at your own pace and comfort level.",
  },
  {
    question: "What questions can I ask?",
    answer:
      "You are welcome to ask any questions that matter to you — whether they concern relationships, career, personal growth, or anything else on your mind. Please note that Stars are deducted based on the duration of your chat, not the number of questions asked, so feel free to inquire about multiple topics during your session.",
  },
  {
    question: "How long can I talk to a psychic?",
    answer:
      "You may continue your conversation for as long as you feel the need for guidance and connection, provided you have Stars available in your balance. There are no limits on the number of messages or duration — simply top up your Stars when needed to continue receiving guidance without interruption.",
  },
]

export const advisorInnerCopy = {
  readings: "Readings",
  usersRating: "Users rating",
  practice: "Practice",
  areasExpertise: "Areas of Expertise",
  aboutMe: "About me",
  specialCategory: "Certified & Trusted",
  comments: "readings",
  guarantee: {
    title: "Validation guarantee",
    subtitle:
      "Our team has verified this advisor’s profile and confirmed their official scientific qualification",
  },
  questions: {
    title: "Frequently asked questions",
  },
  trustedGuide: {
    title: "Meet your \ntrusted guide",
    subtitle: "Expert in love, career, and \nlife guidance",
    button: "Start chat",
  },
  mayLike: {
    title: "You may also like",
    subtitle:
      "Based on your zodiac and preferences, these advisors may have exactly the insight you need",
    button: "Start chat",
  },
  bottomMenu: {
    price: "60 stars/minute",
    button: "Chat",
  },
} as const
